module.exports = __webpack_public_path__ + "img/7a8a2d5.png";